import { HostNameGalleryTable } from '@/features/store-management/premium-stores/galleryManagement/table';
import { useGalleryList } from '@/features/store-management/premium-stores/hooks/useGetGalleryList';
import { galleryListQueries } from '@/services/galleryManagement/galleryManagement.queries';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['reward', 'phoneNumber', 'emailAddress']),
  desc: z.boolean(),
});

const GalleryManagementSearchSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),

  q: z.string().optional(),

  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
});

export const Route = createFileRoute('/(app)/store-information/premium-stores/host-management/gallery/$host-gallery/')({
  component: RouteComponent,

  loader: async ({ context: ctx }) => {
    const queryOptions = galleryListQueries.list();
    const galleryListData = await ctx.queryClient.ensureQueryData({
      ...queryOptions,
      queryFn: queryOptions.queryFn(ctx.client),
    });

    return {
      galleryListData,
    };
  },
  validateSearch: (search: SearchSchemaInput) => GalleryManagementSearchSchema.parse(search),
});

function RouteComponent() {
  const { getGalleryList, isLoading, pagination, commonHostId } = useGalleryList();
  return (
    <HostNameGalleryTable
      data={getGalleryList}
      isLoading={isLoading}
      pagination={pagination}
      commonHostId={commonHostId}
    />
  );
}
